import React from "react";
import { useWatchState } from "@/store";
import { Modal } from "antd";
import "./style.less";

const MODAL_STATE_PATH = "modal.image";

const Video = () => {

    const [[{ title = "", show, hide, width = 900, url }]] = useWatchState([MODAL_STATE_PATH])

    return (
        <Modal
            className="modal-video"
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <img className="m-x-center " src={url} alt="" />
        </Modal>
    );
}

export default Video;